import { combineReducers } from 'redux'
import context1 from './context1'
import auth from './auth'
import publicIssues from './publicIssues'
import issueForm from './issueForm'
import issueView from './issueView'
import search from './search'
import docs from './docs'
import settings from './settings'
import adminDocTypes from './adminDocTypes'
import adminDocTypesForm from './adminDocTypesForm'
import adminEntTypes from './adminEntTypes'
import adminEntTypesForm from './adminEntTypesForm'
import adminRoles from './adminRoles'
import adminRolesForm from './adminRolesForm'
import adminEntities from './adminEntities'
import adminEntitiesForm from './adminEntitiesForm'
import adminUsers from './adminUsers'
import adminUsersForm from './adminUsersForm'
import adminIssues from './adminIssues'
import adminIssuesForm from './adminIssuesForm'
import adminActions from './adminActions'
import adminActionsForm from './adminActionsForm'
import adminPolicies from './adminPolicies'
import adminPoliciesForm from './adminPoliciesForm'
import adminTemplates from './adminTemplates'
import adminTemplatesForm from './adminTemplatesForm'
import adminPrograms from './adminPrograms'
import adminProgramsForm from './adminProgramsForm'

const reducers = combineReducers({
    context1,
    auth,
    publicIssues,
    issueForm,
    issueView,
    search,
    docs,
    settings,
    adminDocTypes,
    adminDocTypesForm,
    adminEntTypes,
    adminEntTypesForm,
    adminRoles,
    adminRolesForm,
    adminEntities,
    adminEntitiesForm,
    adminUsers,
    adminUsersForm,
    adminIssues,
    adminIssuesForm,
    adminActions,
    adminActionsForm,
    adminPolicies,
    adminPoliciesForm,
    adminTemplates,
    adminTemplatesForm,
    adminPrograms,
    adminProgramsForm
})

export default reducers



// WEBPACK FOOTER //
// ./src/reducers/index.js